import React from 'react';
import { Link } from 'react-router-dom';
import img7black from '../../assets/images/img7black.png'
import Fade from 'react-reveal/Fade';
import img3 from '../../assets/images/jon.jpeg'

import '../../assets/css/Button.css';
class About extends React.Component {
    componentDidMount() {
        document.title = "About us";
    }
    render() {
        return (
            <>
                <div className='form'>
                    <h1 style={{ display: 'flex', justifyContent: 'center' }} >About</h1>
                    <Fade left>
                        <div style={{ display: 'flex', justifyContent: 'center' }} className="img">
                            <img width={400} src={img3} alt="png" />
                        </div>
                    </Fade>
                    <p style={{ textAlignVertical: "center", textAlign: "center", paddingLeft: '100px', paddingRight: '100px', paddingTop: '50px', }} >
                        Jonathan “Jon” Gladden is a dedicated Realtor for EXP realty and the CEO of Signature Move Investment Group  for real estate investors in the Maryland area. A native of Maryland, yet raised in Petersburg, VA, he has a long-standing familiarity with the property market in the DMV as well as the southern part of the east coast. As a Veteran who serves in the U.S Army, he considers himself to be a “highly motivated, boots on the ground” realtor, ready to serve each customer. Jon specializes in first-time homebuyers, Veterans using the Va Home loan, and high-end luxury listings. As the CEO of Signature Move Investment Group, Jon offers a high-end company that focuses on new construction, flipping, renovations and large scale modern neighborhood development. He comes from a lineage of public service as his mother served as a college admission clerk and father as building a multi unit rental portfolio. Contact Jonathan Gladden today for you will receive a true professional as your Realtor.
                    </p>
                    <Fade left>
                        <div className="img">
                            <img width={200} src={img7black} alt="png" />
                        </div>
                    </Fade>
                    <h3 style={{ display: 'flex', justifyContent: 'center' }} >Please contact us. We are waiting for your Signature Move!</h3>
                    <Link style={{ display: 'flex', justifyContent: 'center' }} to="/contact" className="btnStyle btnActive" >Contact us</Link>
                </div>
            </>
        )
    }
}
export default About;
